export default __webpack_public_path__ + "static/media/ecommerce.3468ee53.png";